const convertMss = (time) => {
  let mm = time % 60;
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${parseInt(time / 60)}:${mm}`;
};

const DisplayTimeBox = ({ timeInfo }) => {
  return (
    <div className="answer-time text-align-center">
      <p className="time">
        준비시간 <b>{convertMss(timeInfo.ready_time_second)}</b>
      </p>
      <p className="time">
        최소 답변시간 <b>{convertMss(timeInfo.minres_time_second)}</b>
      </p>
      <p className="time">
        최대 답변시간 <b>{convertMss(timeInfo.maxres_time_second)}</b>
      </p>
    </div>
  );
};

export default DisplayTimeBox;
